 export const PART_TO_PAGE = {
    warehouse: "warehouse",
    cashRegisters: "checkout",
    posts: "station",
    suppliers: "distributors",
    staff: "staff",
    price: "price",
  };